import { cn } from '@/lib/utils';

import type { McpCallStatus } from '../mcp-info.types';

export function McpInfoStatusBadge({ status }: { status: McpCallStatus }) {
  return (
    <span
      className={cn(
        'px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase',
        status === 'success'
          ? 'bg-success-3 text-success-11'
          : 'bg-danger-3 text-danger-11'
      )}
    >
      {status}
    </span>
  );
}
